import type { ReactNode } from 'react';

import { ThemeContextProvider, useThemeRoot } from '../../../hooks/use-theme';

// Note: this is also required for the storybook
import '@repo/ui/assets/index.scss';

interface ThemeWrapperProps {
  children: ReactNode;
}

export function ThemeWrapper({ children }: ThemeWrapperProps) {
  const theme = useThemeRoot();

  return <ThemeContextProvider value={theme}>{children}</ThemeContextProvider>;
}
